import { application } from "../helpers/stimulus"

import DisclosureItemController from "../controllers/disclosure_item_controller"
import FooterController from "../controllers/footer_controller"

const setupFooter = (): void => {
  application.register("disclosure-item", DisclosureItemController)
  application.register("footer", FooterController)
}

export { setupFooter }
